import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getDirectoryPlumberBySlug } from '../../lib/api/directory'
import type { DirectoryPlumberProfile } from '../../types/directory'

/**
 * Resolves /plumbers/find/:directorySlug → full profile URL.
 * Used by Discord notifications and admin links.
 */
export function DirectoryPlumberFinder() {
  const { directorySlug } = useParams<{ directorySlug: string }>()
  const navigate = useNavigate()

  const { data: plumber, error } = useQuery({
    queryKey: ['plumber-find', directorySlug],
    queryFn: () => getDirectoryPlumberBySlug(directorySlug!),
    enabled: !!directorySlug,
    retry: false,
  })

  useEffect(() => {
    if (!plumber) return
    const p = plumber as DirectoryPlumberProfile & { regionSlug?: string }
    // Use 'gb'/'unknown' placeholders for plumbers without full geo data (e.g. TrustATrader).
    // The profile route server-side falls back to findOne({ directorySlug }) when geo segments don't match.
    const countrySlug = p.countrySlug || 'gb'
    const countySlug = p.regionSlug || 'unknown'
    const citySlug = p.citySlug || 'unknown'
    const postcodeArea = p.postcodeArea || 'unknown'
    const slug = p.directorySlug
    if (slug) {
      navigate(`/plumbers/${countrySlug}/${countySlug}/${citySlug}/${postcodeArea.toLowerCase()}/${slug}`, { replace: true })
    }
  }, [plumber, navigate])

  if (error) return <div className="p-8 text-center text-gray-500">Plumber not found.</div>

  return <div className="p-8 text-center text-gray-400">Loading…</div>
}
